<template>
  <div class="Overlay Overlay-sup">
    <div class="ModalBox ModalBox--central Modal--filters sup2"
    :class="modalClass"
    >
      <div class="ModalBox-header d-flex justify-content-between align-items-center p-3"
      >
        <button
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close"
          @click="handleClose"
          v-if="!hideClose"
        >
          <img
            class="Fuell-IconButton--close-img"
            :src="require('@/assets/img/icons/close.svg')"
            alt="Close"
          />
        </button>
        <slot name="header"></slot>
      </div>
      <div class="ModalBox-container mt-5"
      :class="contentClass"
      >
        <slot name="content"></slot>
      </div>
      <div :class="footerClass">
        <slot name="footer"></slot>
      </div>
      <slot name="modals"></slot>

    </div>
  </div>

</template>

<script>
export default {
  name: 'CentralModal',
  props: {
    modalClass: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    },
    footerClass: {
      type: String,
      default: ''
    },
    hideClose: {
      type: Boolean,
      default: false
    },
    hideOverlay: {
      type: Boolean,
      default: false
    }

  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }

}
</script>

<style>
</style>
